import "./App.css";
import "./NewStyle.css";
import "./Responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-svg-map/lib/index.css";
import "react-modern-drawer/dist/index.css";
import Header from "./components/header/Header";
import Home from "./components/Home/Home";
import Footer from "./components/footer/Footer";
import {
  Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import Katbook from "./components/Katbook/Katbook";
import { useEffect, useRef, useState } from "react";
import ModalComponent from "./components/modalComponent/ModalComponent";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Inventor from "./components/Inventor/Inventor";
import Bookfetch from "./components/BookFetch/Bookfetch";
import Public from "./Routes/Public";
import Private from "./Routes/Private";
// import {BrowserRouter as Router,Routes,Route } from 'react-router-dom'
import "./components/header/Header.css";
import { TailSpin } from "react-loader-spinner";
import { SessionStoreValue } from "./Helpers/utils";
import PrivateRoute from "./PrivateRoute";
import Katbook_new from "./components/Katbook/Katbook_new";
import UEducate from "./components/UEducate/UEducate";
import Evaluation from "./components/Evaluation/Evaluation";
import UTeachFoundation from "./components/Katbook Foundation/UTeach";
import ULearnFoundation from "./components/Katbook Foundation/ULearn";
import UTeachStandard from "./components/Katbook Standards/UTeach";
import ULearnStandard from "./components/Katbook Standards/ULearn";
import AdminLogin from "./AdminLogin/AdminLogin";
import SuperAdminLogin from "./AdminLogin/SuperAdminLogin";
import SuperAdminPage from "./super Admin page/SuperAdminPage";
import useVersionCheck from "./useVersionCheck"
import { getAllCountries } from "./Services/ApiService"

function App() {
  useVersionCheck();
  const ref = useRef(null);
  const ref2 = useRef(null);
  const [subjectArr, setsubjectArr] = useState([]);
  const [allCountries, setallCountries] = useState([]);

  const RoutesClick = () => {
    navigate("/");
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const NCERTClick = () => {
    navigate("/");
    setTimeout(() => {
      ref2.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const [isLoading, setIsLoading] = useState(true);
  const isAuthenticate = SessionStoreValue();
  const navigate = useNavigate();
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      console.log = () => {};
      console.error = () => {};
      console.debug = () => {};
      console.warn = () => {};
    }

    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
    setTimeout(async () => {
      setIsLoading(false);
    }, 1000);
    AllCountriesFunc()
  }, []);

  const AllCountriesFunc = async () => {

    let result = await getAllCountries();
    if(result?.success && result?.data?.length > 0){
      let data = result?.data.map((country) => ({
            label: country?.combined,
            value: country?._id,
            minLength: country?.minLength,
            maxLength: country?.maxLength,
            dialingCode: country?.dialingCode
          }));

      setallCountries(data)
      console.log(data,"country list");
    }
  }

  useEffect(() => {
    var lastScrollTop;
    let navbar = document.getElementById("navbar");
    console.log(navbar, "qqqqqqq");
    const handleScroll = () => {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        navbar.style.top = "-80px";
      } else {
        navbar.style.top = "0px";
      }
      lastScrollTop = scrollTop;
    };

    // Check screen width before adding the scroll event listener
    const addScrollListener = () => {
      if (navbar !== null && navbar !== undefined) {
        if (window.innerWidth > 600) {
          window.addEventListener("scroll", handleScroll);
        }
      }
    };

    addScrollListener(); // Add the listener initially

    // Cleanup: Remove the scroll event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // useEffect(() => {
  //   // Scroll to the top of the page when the component mounts
  //   window.scrollTo(0, 0);

  //   // Check if the current pathname is not the root path ('/')
  //   if (window.location.pathname !== "/") {
  //     // Redirect to the home page
  //     window.location.href = "/";
  //   }
  // }, []);

  // const handleTabClickHeader = (tab) => {
  //   setActiveTabHeader(tab);
  // };

  // const [activeTabHeader, setActiveTabHeader] = useState("Home");

  // const [studentregisterModal, setStudentRegisterModal] = useState(false);

  // const [ParentregisterModal, setParentRegisterModal] = useState(false);
  // const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  console.log(localStorage.getItem("token"), "isAuthenticate");

  const [selectedLang, setSelectedLang] = useState("en");
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  // On app mount/URL change, check if lang param irukka, illana, add default:
  useEffect(() => {
    let currentLang = searchParams.get("lang");
    if (!currentLang) {
      setSearchParams({ lang: selectedLang });
    } else if (currentLang !== selectedLang) {
      setSelectedLang(currentLang);
    }
    // eslint-disable-next-line
  }, [location.pathname, location.search]);

  console.log(location,"location");
  

  // Whenever language change aagara, update the URL
  useEffect(() => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("lang", selectedLang);
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    // eslint-disable-next-line
  }, [selectedLang]);

  const UserProfileType = JSON.parse(localStorage.getItem("userType"));
  console.log(UserProfileType, "123");

  return (
    <>
      {isLoading ? (
        // Display loader while loading
        // <div>Loading...</div>
        <div className="loader-container">
          {/* <TailSpin
            color="#00BFFF"
            height={80}
            width={80}
            timeout={10000}
          /> */}
          <img
            src="https://cdn.katbook.com/assets/sites/ncert/754664531191533568_educationloader.gif"
            alt="Loader"
          />
        </div>
      ) : (
        <>
          <Routes>
            <Route
              path="/"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Home
                    Rootsref={ref}
                    Ncertref={ref2}
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    setsubjectArr={setsubjectArr}
                    subjectArr={subjectArr}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/user/register"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : localStorage.getItem("token") ? (
                  <Navigate to="/" />
                ) : (
                  <Home
                    Rootsref={ref}
                    Ncertref={ref2}
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    setsubjectArr={setsubjectArr}
                    subjectArr={subjectArr}
                    allCountries={allCountries}
                  />
                )
              }
            />
            {/* <Route exact path="/" element={<Home />} /> */}
            {/* <Route path="/inventor" element={localStorage.getItem('token') === null ? <Inventor RoutesClick={RoutesClick} NcertClick={NCERTClick} /> : <Navigate to="/bookview" />} /> */}
            {/* <Route path="/katbook" element={localStorage.getItem('token') === null ? <Katbook RoutesClick={RoutesClick} NcertClick={NCERTClick} /> : <Navigate to="/bookview" />} /> */}
            <Route
              path="/katbook"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Katbook_new
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/ueducate"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <UEducate
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/feedback"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Evaluation
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/katbook/uteach/foundation"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <UTeachFoundation
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/katbook/ulearn/foundation"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <ULearnFoundation
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/katbook/uteach/standard"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <UTeachStandard
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            <Route
              path="/katbook/ulearn/standard"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <ULearnStandard
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    allCountries={allCountries}
                  />
                )
              }
            />
            {/* <PrivateRoute path="/bookview" element={<Bookfetch />} /> */}
            <Route
              path="/bookview"
              element={
                UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : localStorage.getItem("token") ? (
                  <Bookfetch
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                    setsubjectArr={setsubjectArr}
                    subjectArr={subjectArr}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/dashboard"
              element={
                (localStorage.getItem("token") && UserProfileType?.usertype === "SuperAdmin") ? (
                  <SuperAdminPage
                    RoutesClick={RoutesClick}
                    NcertClick={NCERTClick}
                    selectedLang={selectedLang}
                    setSelectedLang={setSelectedLang}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/ad-login"
              element={
                localStorage.getItem("token") === null ? (
                  <AdminLogin />
                ) : UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <AdminLogin />
                )
              }
            />
            <Route
              path="/superad-login"
              element={
                localStorage.getItem("token") === null ? (
                  <SuperAdminLogin />
                ) : UserProfileType?.usertype === "SuperAdmin" ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <SuperAdminLogin />
                )
              }
            />
          </Routes>
          <ToastContainer />
        </>
      )}
    </>
  );
}

export default App;
